// extracted by mini-css-extract-plugin
export default {"surfaceType":"components--surfaceType--0-xQt"};